/* eslint-disable @typescript-eslint/no-empty-function */
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, ContentChild, ElementRef, EventEmitter, Input, Output, SimpleChange, ViewChild, ViewEncapsulation, } from '@angular/core';
import { ButtonPurpose } from '@mhe/ngx-shared/button';
import { TemplateUuids, getFocusableElements, provideValueAccessor, } from '@mhe/ngx-shared/utils';
import { differenceWith, isEqual, uniqBy } from 'lodash-es';
import { Subject, Subscription, merge, takeUntil } from 'rxjs';
import dropdownPositions from './dropdown-positions';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/overlay";
import * as i2 from "@mhe/ngx-shared/translate";
import * as i3 from "@angular/common";
import * as i4 from "@angular/router";
import * as i5 from "@angular/cdk/portal";
import * as i6 from "@mhe/ngx-shared/checkbox";
const _c0 = ["mheDropdownTrigger"];
const _c1 = ["controlButton"];
const _c2 = ["toggleButtonWithIcon"];
const _c3 = ["splitActionButton"];
const _c4 = ["dropdownMenuPortal"];
const _c5 = function (a0) { return { open: a0 }; };
const _c6 = function (a0) { return { "width.px": a0 }; };
function DropdownComponent_ng_container_1_ng_container_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10, 11);
    i0.ɵɵlistener("click", function DropdownComponent_ng_container_1_ng_container_1_button_1_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r16.toggleMenu($event)); });
    i0.ɵɵelementStart(2, "span", 12)(3, "span", 13);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r12.setButtonClass());
    i0.ɵɵproperty("id", ctx_r12.templateUuids.get("buttonId"))("ngClass", i0.ɵɵpureFunction1(9, _c5, ctx_r12.isExpanded))("ngStyle", i0.ɵɵpureFunction1(11, _c6, ctx_r12.buttonWidth));
    i0.ɵɵattribute("disabled", ctx_r12.disabledProp(ctx_r12.disabled))("aria-expanded", ctx_r12.isExpanded);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", ctx_r12.toggleButtonAriaLabel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r12.currentSelection, " ");
} }
function DropdownComponent_ng_container_1_ng_container_1_ng_template_2_img_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 18);
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("src", ctx_r19.image, i0.ɵɵsanitizeUrl);
} }
function DropdownComponent_ng_container_1_ng_container_1_ng_template_2_i_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i");
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMapInterpolate1(" ", ctx_r20.icon, "");
} }
const _c7 = function (a0) { return { "btn-padding": a0 }; };
function DropdownComponent_ng_container_1_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14, 15);
    i0.ɵɵlistener("click", function DropdownComponent_ng_container_1_ng_container_1_ng_template_2_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r21.toggleMenu($event)); });
    i0.ɵɵelementStart(2, "span", 13);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, DropdownComponent_ng_container_1_ng_container_1_ng_template_2_img_4_Template, 1, 1, "img", 16);
    i0.ɵɵtemplate(5, DropdownComponent_ng_container_1_ng_container_1_ng_template_2_i_5_Template, 1, 3, "i", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", ctx_r14.templateUuids.get("buttonId"))("ngClass", i0.ɵɵpureFunction1(7, _c7, ctx_r14.image));
    i0.ɵɵattribute("disabled", ctx_r14.disabledProp(ctx_r14.disabled))("aria-expanded", ctx_r14.isExpanded);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r14.toggleButtonAriaLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.image);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.icon && !ctx_r14.image);
} }
function DropdownComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DropdownComponent_ng_container_1_ng_container_1_button_1_Template, 6, 13, "button", 8);
    i0.ɵɵtemplate(2, DropdownComponent_ng_container_1_ng_container_1_ng_template_2_Template, 6, 9, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r13 = i0.ɵɵreference(3);
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r11.icon && !ctx_r11.image)("ngIfElse", _r13);
} }
function DropdownComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DropdownComponent_ng_container_1_ng_container_1_Template, 4, 2, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r7 = i0.ɵɵreference(9);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.splitActionText)("ngIfElse", _r7);
} }
function DropdownComponent_ng_template_2_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 23)(1, "div", 24)(2, "input", 25);
    i0.ɵɵlistener("blur", function DropdownComponent_ng_template_2_li_2_Template_input_blur_2_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r26.searchIsFocused = false); })("focus", function DropdownComponent_ng_template_2_li_2_Template_input_focus_2_listener() { i0.ɵɵrestoreView(_r27); const ctx_r28 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r28.searchIsFocused = true); })("keyup", function DropdownComponent_ng_template_2_li_2_Template_input_keyup_2_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r29 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r29.searchOptions($event)); });
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "mheTranslate");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 1, i0.ɵɵpipeBind1(4, 3, "ngx-shared-search")));
} }
function DropdownComponent_ng_template_2_li_3_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 26)(1, "div", 27)(2, "label", 28)(3, "input", 29);
    i0.ɵɵlistener("change", function DropdownComponent_ng_template_2_li_3_Template_input_change_3_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r30.selectAllOptions()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵpipe(6, "mheTranslate");
    i0.ɵɵelementStart(7, "span", 30);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "async");
    i0.ɵɵpipe(10, "mheTranslate");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    let tmp_1_0;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("checked", ctx_r24.allSelected)("indeterminate", !ctx_r24.allSelected && ((tmp_1_0 = ctx_r24.selected == null ? null : ctx_r24.selected.length) !== null && tmp_1_0 !== undefined ? tmp_1_0 : 0) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 4, i0.ɵɵpipeBind1(6, 6, "ngx-shared-select-all")), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 8, i0.ɵɵpipeBind1(10, 10, "ngx-shared-menu-option")));
} }
function DropdownComponent_ng_template_2_li_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c8 = function (a0, a1) { return { "px-2 py-1": a0, "pe-none": a1 }; };
const _c9 = function (a0) { return { "margin-left": a0 }; };
function DropdownComponent_ng_template_2_li_4_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 31, 32);
    i0.ɵɵlistener("click", function DropdownComponent_ng_template_2_li_4_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r37); const option_r32 = restoredCtx.$implicit; const ctx_r36 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(!ctx_r36.multiple ? ctx_r36.selectOption(option_r32) : ""); });
    i0.ɵɵtemplate(2, DropdownComponent_ng_template_2_li_4_ng_container_2_Template, 1, 0, "ng-container", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r32 = ctx.$implicit;
    const i_r33 = ctx.index;
    const ctx_r25 = i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(7);
    i0.ɵɵclassProp("disabled", option_r32.disabled)("checkmark", !ctx_r25.multiple && ctx_r25.containsOption(option_r32, ctx_r25.selected))("dpg-icon-confirmation", !ctx_r25.multiple && ctx_r25.containsOption(option_r32, ctx_r25.selected))("option-group-options", ctx_r25._isChild[i_r33])("option-group-title", !!option_r32.children);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(15, _c8, ctx_r25.multiple, !!option_r32.children))("ngStyle", i0.ɵɵpureFunction1(18, _c9, !!option_r32.children ? "-1rem" : null));
    i0.ɵɵattribute("aria-disabled", option_r32.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", ctx_r25.getContext(i_r33, option_r32));
} }
function DropdownComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵlistener("@hideDropdown.done", function DropdownComponent_ng_template_2_Template_div_animation_hideDropdown_done_0_listener($event) { i0.ɵɵrestoreView(_r39); const ctx_r38 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r38.hideDropdownAnimationDone($event)); });
    i0.ɵɵelementStart(1, "ul", 19);
    i0.ɵɵlistener("scroll", function DropdownComponent_ng_template_2_Template_ul_scroll_1_listener($event) { i0.ɵɵrestoreView(_r39); const ctx_r40 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r40.onScroll($event)); })("keydown", function DropdownComponent_ng_template_2_Template_ul_keydown_1_listener($event) { i0.ɵɵrestoreView(_r39); const ctx_r41 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r41.onKey($event)); });
    i0.ɵɵtemplate(2, DropdownComponent_ng_template_2_li_2_Template, 5, 5, "li", 20);
    i0.ɵɵtemplate(3, DropdownComponent_ng_template_2_li_3_Template, 11, 12, "li", 21);
    i0.ɵɵtemplate(4, DropdownComponent_ng_template_2_li_4_Template, 3, 20, "li", 22);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@hideDropdown", !ctx_r2.multiple && ctx_r2.triggerHideDropdown ? "dropdownHidden" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("dropdown-menu-right", ctx_r2.optionPosition === "left");
    i0.ɵɵattribute("aria-label", ctx_r2.listboxLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.filterable || ctx_r2.searchable);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.multiple && ctx_r2.selectAll);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.options)("ngForTrackBy", ctx_r2.trackById);
} }
function DropdownComponent_ng_template_4_i_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 39);
} if (rf & 2) {
    const viewIcon_r47 = ctx.$implicit;
    i0.ɵɵclassMapInterpolate1("dpg-icon ", viewIcon_r47.class, "");
    i0.ɵɵpropertyInterpolate("title", viewIcon_r47.label);
} }
function DropdownComponent_ng_template_4_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 40);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const viewDescription_r44 = i0.ɵɵnextContext().viewDescription;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(viewDescription_r44);
} }
const _c10 = function (a0) { return { "view-title": a0 }; };
function DropdownComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34)(1, "span", 35);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 36);
    i0.ɵɵtemplate(4, DropdownComponent_ng_template_4_i_4_Template, 1, 4, "i", 37);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, DropdownComponent_ng_template_4_p_5_Template, 2, 1, "p", 38);
} if (rf & 2) {
    const viewValue_r42 = ctx.viewValue;
    const viewIcons_r43 = ctx.viewIcons;
    const viewDescription_r44 = ctx.viewDescription;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c10, viewDescription_r44));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(viewValue_r42);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", viewIcons_r43);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", viewDescription_r44);
} }
function DropdownComponent_ng_template_6_ng_container_0_button_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DropdownComponent_ng_template_6_ng_container_0_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r59 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 45);
    i0.ɵɵlistener("@optionSelection.done", function DropdownComponent_ng_template_6_ng_container_0_button_1_Template_button_animation_optionSelection_done_0_listener($event) { i0.ɵɵrestoreView(_r59); const ctx_r58 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r58.optionSelectionAnimationDone($event)); })("click", function DropdownComponent_ng_template_6_ng_container_0_button_1_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r59); const option_r49 = i0.ɵɵnextContext(2).option; const ctx_r60 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r60.linkClickHandler($event, option_r49)); })("focus", function DropdownComponent_ng_template_6_ng_container_0_button_1_Template_button_focus_0_listener($event) { i0.ɵɵrestoreView(_r59); const option_r49 = i0.ɵɵnextContext(2).option; const ctx_r62 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r62.linkFocusHandler($event, option_r49)); });
    i0.ɵɵtemplate(1, DropdownComponent_ng_template_6_ng_container_0_button_1_ng_container_1_Template, 1, 0, "ng-container", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r64 = i0.ɵɵnextContext(2);
    const isHeader_r51 = ctx_r64.option.children;
    const option_r49 = ctx_r64.option;
    const ctx_r54 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(5);
    i0.ɵɵclassProp("is-header", isHeader_r51 || null)("disabled", option_r49.disabled)("fw-semibold", !!option_r49.children);
    i0.ɵɵproperty("@optionSelection", ctx_r54.triggerOptionSelectionAnimation && ctx_r54.containsOption(option_r49, ctx_r54.selected) ? "selected" : "");
    i0.ɵɵattribute("tabindex", !option_r49.disabled && !option_r49.children ? 0 : null)("aria-label", ctx_r54.getOptionLabel(option_r49))("aria-selected", ctx_r54.containsOption(option_r49, ctx_r54.selected));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3)("ngTemplateOutletContext", option_r49);
} }
function DropdownComponent_ng_template_6_ng_container_0_a_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DropdownComponent_ng_template_6_ng_container_0_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r67 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 46);
    i0.ɵɵlistener("@optionSelection.done", function DropdownComponent_ng_template_6_ng_container_0_a_2_Template_a_animation_optionSelection_done_0_listener($event) { i0.ɵɵrestoreView(_r67); const ctx_r66 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r66.optionSelectionAnimationDone($event)); })("click", function DropdownComponent_ng_template_6_ng_container_0_a_2_Template_a_click_0_listener($event) { i0.ɵɵrestoreView(_r67); const option_r49 = i0.ɵɵnextContext(2).option; const ctx_r68 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r68.linkClickHandler($event, option_r49)); })("focus", function DropdownComponent_ng_template_6_ng_container_0_a_2_Template_a_focus_0_listener($event) { i0.ɵɵrestoreView(_r67); const option_r49 = i0.ɵɵnextContext(2).option; const ctx_r70 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r70.linkFocusHandler($event, option_r49)); });
    i0.ɵɵtemplate(1, DropdownComponent_ng_template_6_ng_container_0_a_2_ng_container_1_Template, 1, 0, "ng-container", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r72 = i0.ɵɵnextContext(2);
    const option_r49 = ctx_r72.option;
    const isHeader_r51 = ctx_r72.option.children;
    const ctx_r55 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(5);
    i0.ɵɵclassProp("disabled", option_r49.disabled)("is-header", isHeader_r51 || null);
    i0.ɵɵpropertyInterpolate("href", option_r49.href, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("target", option_r49.target);
    i0.ɵɵproperty("@optionSelection", ctx_r55.triggerOptionSelectionAnimation && ctx_r55.containsOption(option_r49, ctx_r55.selected) ? "selected" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3)("ngTemplateOutletContext", option_r49);
} }
function DropdownComponent_ng_template_6_ng_container_0_a_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DropdownComponent_ng_template_6_ng_container_0_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r75 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 47);
    i0.ɵɵlistener("@optionSelection.done", function DropdownComponent_ng_template_6_ng_container_0_a_3_Template_a_animation_optionSelection_done_0_listener($event) { i0.ɵɵrestoreView(_r75); const ctx_r74 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r74.optionSelectionAnimationDone($event)); })("click", function DropdownComponent_ng_template_6_ng_container_0_a_3_Template_a_click_0_listener($event) { i0.ɵɵrestoreView(_r75); const option_r49 = i0.ɵɵnextContext(2).option; const ctx_r76 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r76.linkClickHandler($event, option_r49)); })("focus", function DropdownComponent_ng_template_6_ng_container_0_a_3_Template_a_focus_0_listener($event) { i0.ɵɵrestoreView(_r75); const option_r49 = i0.ɵɵnextContext(2).option; const ctx_r78 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r78.linkFocusHandler($event, option_r49)); });
    i0.ɵɵtemplate(1, DropdownComponent_ng_template_6_ng_container_0_a_3_ng_container_1_Template, 1, 0, "ng-container", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r80 = i0.ɵɵnextContext(2);
    const option_r49 = ctx_r80.option;
    const isHeader_r51 = ctx_r80.option.children;
    const ctx_r56 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(5);
    i0.ɵɵclassProp("disabled", option_r49.disabled)("is-header", isHeader_r51 || null);
    i0.ɵɵpropertyInterpolate("routerLink", option_r49.routerLink);
    i0.ɵɵproperty("@optionSelection", ctx_r56.triggerOptionSelectionAnimation && ctx_r56.containsOption(option_r49, ctx_r56.selected) ? "selected" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3)("ngTemplateOutletContext", option_r49);
} }
function DropdownComponent_ng_template_6_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DropdownComponent_ng_template_6_ng_container_0_button_1_Template, 2, 12, "button", 42);
    i0.ɵɵtemplate(2, DropdownComponent_ng_template_6_ng_container_0_a_2_Template, 2, 9, "a", 43);
    i0.ɵɵtemplate(3, DropdownComponent_ng_template_6_ng_container_0_a_3_Template, 2, 8, "a", 44);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const option_r49 = i0.ɵɵnextContext().option;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !option_r49.routerLink && !option_r49.href || option_r49.disabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", option_r49.href);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", option_r49.routerLink);
} }
function DropdownComponent_ng_template_6_ng_container_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DropdownComponent_ng_template_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r85 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 27)(2, "label", 28)(3, "input", 48);
    i0.ɵɵlistener("change", function DropdownComponent_ng_template_6_ng_container_1_Template_input_change_3_listener() { i0.ɵɵrestoreView(_r85); const option_r49 = i0.ɵɵnextContext().option; const ctx_r83 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r83.selectOption(option_r49)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, DropdownComponent_ng_template_6_ng_container_1_ng_container_4_Template, 1, 0, "ng-container", 33);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const option_r49 = i0.ɵɵnextContext().option;
    const ctx_r53 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(5);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", option_r49.value)("checked", ctx_r53.containsOption(option_r49, ctx_r53.selected));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3)("ngTemplateOutletContext", option_r49);
} }
function DropdownComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, DropdownComponent_ng_template_6_ng_container_0_Template, 4, 3, "ng-container", 41);
    i0.ɵɵtemplate(1, DropdownComponent_ng_template_6_ng_container_1_Template, 5, 4, "ng-container", 41);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r6.multiple);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.multiple);
} }
const _c11 = function (a0, a1) { return { placeholder: a0, open: a1 }; };
function DropdownComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    const _r90 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 49, 50);
    i0.ɵɵlistener("click", function DropdownComponent_ng_template_8_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r90); const ctx_r89 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r89.splitActionClick.emit($event)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 51, 11);
    i0.ɵɵlistener("click", function DropdownComponent_ng_template_8_Template_button_click_3_listener($event) { i0.ɵɵrestoreView(_r90); const ctx_r91 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r91.toggleMenu($event)); });
    i0.ɵɵelementStart(5, "i", 52)(6, "span", 13);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r8.templateUuids.get("buttonId"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.splitActionText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c11, ctx_r8.hasPlaceholderText(ctx_r8.selected), ctx_r8.isExpanded));
    i0.ɵɵattribute("disabled", ctx_r8.disabledProp(ctx_r8.disabled))("aria-expanded", ctx_r8.isExpanded);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r8.toggleButtonAriaLabel);
} }
function DropdownComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0);
} }
const _c12 = ["*"];
const DROPDOWN_SELECTED_STATE_TIME = 250;
export class DropdownComponent {
    constructor(changeDetectorRef, overlay, translateService) {
        this.changeDetectorRef = changeDetectorRef;
        this.overlay = overlay;
        this.translateService = translateService;
        this.minWidth = 0;
        this.maxWidth = 250;
        this.useCustomTrigger = false;
        this.splitActionText = null;
        this.disabled = false;
        this.optionPosition = 'left';
        this.toggleButtonAriaLabel = '';
        this.icon = '';
        this.multiple = false;
        this.filterable = false;
        this.syncWidths = false;
        this.searchable = false;
        this.selectAll = true;
        this.selectAllText = 'Select all';
        this.placeholder = 'Select';
        this.panelClass = '';
        this.closeOnBlur = false;
        this.buttonClass = 'btn btn-secondary dropdown-toggle';
        /** Flattened list of all options */
        this._flatOptions = [];
        /** Filtered list of options to display */
        this._filteredOptions = [];
        /** Search term for filtering options */
        this._searchTerm = '';
        this.selectionChange = new EventEmitter();
        this.searchTerm = new EventEmitter();
        this.scrollBottomReached = new EventEmitter();
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.close = new EventEmitter();
        this.splitActionClick = new EventEmitter();
        this._closingActionsSubscription = Subscription.EMPTY;
        this.destroy$ = new Subject();
        // expose import to template
        this._buttonPurpose = ButtonPurpose;
        this.allSelected = false;
        this.focusedOption = null;
        this.isExpanded = false;
        this.searchIsFocused = false;
        this.selectedSuffix = 'selected';
        this.templateUuids = new TemplateUuids();
        this.triggerHideDropdown = false;
        this.triggerOptionSelectionAnimation = false;
        this._onChange = (_) => { };
        this._onTouch = () => { };
    }
    get options() {
        return this._filteredOptions;
    }
    set options(options) {
        this._isChild = [];
        this._flatOptions = (options !== null && options !== void 0 ? options : []).reduce((acc, cur) => {
            var _a;
            this._isChild.push(false);
            const children = (_a = cur.children) !== null && _a !== void 0 ? _a : [];
            for (const _c of children) {
                this._isChild.push(true);
            }
            return [...acc, cur, ...children];
        }, []);
        this._filteredOptions = this.filterOptions(this._searchTerm);
        this.checkSelectAll();
    }
    // value
    get value() {
        var _a;
        return (_a = this.selected) !== null && _a !== void 0 ? _a : [];
    }
    set value(value) {
        this.selected = value;
    }
    /** miscl. getters */
    get currentSelection() {
        return this.getDropdownDisplay(this.selected, this.placeholder);
    }
    // TODO: this smells like an anti-pattern
    get buttonId() {
        return this.templateUuids.get('buttonId');
    }
    get hasIcon() {
        return this.icon !== '';
    }
    get dropdownTrigger() {
        const button = this.controlButton || this.toggleButtonWithIcon || this.splitActionButton || this.customTrigger;
        return button.nativeElement;
    }
    get customTrigger() {
        return this.trigger;
    }
    ngOnInit() {
        this.translateService.translate('ngx-shared-selected').subscribe((value) => {
            this.selectedSuffix = value;
        });
    }
    ngOnDestroy() {
        this.hideDropdown(true);
        this.destroy$.next();
        this.destroy$.unsubscribe();
    }
    ngOnChanges(changes) {
        var _a, _b;
        if (changes.options) {
            const options = (_a = changes.options.currentValue) !== null && _a !== void 0 ? _a : [];
            if (uniqBy(options, 'value').length !== options.length) {
                throw new Error('options must have unique values');
            }
        }
        if (changes.selected) {
            const selected = (_b = changes.selected.currentValue) !== null && _b !== void 0 ? _b : [];
            if (!this.multiple && selected.length > 1) {
                throw new Error('selected must contain only one element unless multiple is true');
            }
            this.checkSelectAll();
        }
    }
    setButtonClass() {
        if (typeof this.buttonClass === 'string') {
            return this.buttonClass;
        }
        else {
            return this.buttonClass.join(' ');
        }
    }
    createDropdownPortal() {
        const optionPosition = this.splitActionText ? 'right' : this.optionPosition;
        this.overlayRef = this.overlay.create({
            positionStrategy: this.getPositionStrategy(optionPosition),
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
            maxWidth: '50vmax',
            maxHeight: '33rem',
            minWidth: 'fit-content',
            panelClass: [this.panelClass, 'dropdown-menu', 'ngx-shared', 'd-block', 'overflow-auto', 'p-0'],
        });
    }
    getPositionStrategy(optionPosition) {
        const { bottom_left, bottom_right, top_left, top_right } = dropdownPositions;
        const positions = optionPosition === 'right' ? [bottom_right, top_right] : [bottom_left, top_left];
        // Flexible position strategy bounds dropdown by window and allows to grow to maximize possible height
        const positionStrategy = this.overlay
            .position()
            .flexibleConnectedTo(this.dropdownTrigger)
            .withFlexibleDimensions(true)
            .withGrowAfterOpen(true)
            .withPush(false)
            .withPositions([...positions]);
        return positionStrategy;
    }
    toggleMenu(_event) {
        this.isExpanded ? this.hideDropdown() : this.showDropdown();
    }
    showDropdown() {
        if (this.isExpanded) {
            return;
        }
        this.createDropdownPortal();
        if (this.dropdownMenuPortal) {
            this.overlayRef.attach(this.dropdownMenuPortal);
            this.listItems = Array.from(this.overlayRef.hostElement.querySelectorAll('li[role="presentation"]'));
            this.setClosingActions();
            if (!this.multiple) {
                const initialSelection = this.getInitialSelectionLink();
                this.focusedOption = initialSelection;
                if (initialSelection) {
                    setTimeout(() => initialSelection.focus());
                }
            }
            else {
                this.focusControlButton();
            }
            this.isExpanded = true;
        }
    }
    hideDropdown(returnFocus = true) {
        var _a;
        this.triggerHideDropdown = false;
        if ((_a = this.overlayRef) === null || _a === void 0 ? void 0 : _a.hasAttached()) {
            this._closingActionsSubscription.unsubscribe();
            this.overlayRef.detach();
            this.overlayRef.dispose();
            if (returnFocus) {
                this.focusControlButton();
            }
        }
        this.isExpanded = false;
        this.changeDetectorRef.detectChanges();
        this.close.emit();
        if (this.isMenu) {
            this.resetSelectedState();
        }
    }
    resetSelectedState() {
        this.selected = [];
    }
    width() {
        const { dropdownTrigger, syncWidths } = this;
        const bounds = dropdownTrigger.getBoundingClientRect();
        return syncWidths ? bounds.width : 'auto';
    }
    getContext(i, option) {
        return { isChild: this._isChild[i], option };
    }
    containsOption(target, options) {
        return options === null || options === void 0 ? void 0 : options.some((option) => option.value === target.value);
    }
    selectOption(selectedOption) {
        var _a, _b;
        if (selectedOption.disabled || !!selectedOption.children) {
            return;
        }
        if (!this.multiple) {
            this.selected = [selectedOption];
            this.triggerOptionSelectionAnimation = true;
        }
        else {
            if (this.containsOption(selectedOption, this.selected)) {
                this.selected = (_a = this.selected) === null || _a === void 0 ? void 0 : _a.filter((option) => option.value !== selectedOption.value);
            }
            else {
                this.selected = ((_b = this.selected) !== null && _b !== void 0 ? _b : []).concat(selectedOption);
            }
        }
        this.updateDropdown();
    }
    optionSelectionAnimationDone(event) {
        if (event.toState === 'selected') {
            this.triggerHideDropdown = true;
            this.triggerOptionSelectionAnimation = false;
        }
    }
    hideDropdownAnimationDone(event) {
        if (event.toState === 'dropdownHidden') {
            this.hideDropdown();
        }
    }
    selectAllOptions() {
        if (this.allSelected) {
            this.selected = [];
        }
        else {
            this.selected = [...this.options];
        }
        this.updateDropdown();
    }
    checkSelectAll() {
        var _a;
        if (((_a = this.selected) === null || _a === void 0 ? void 0 : _a.length) && this.options.length === this.selected.length) {
            this.allSelected = !differenceWith(this.options, this.selected, isEqual).length;
        }
        else {
            this.allSelected = false;
        }
    }
    updateDropdown() {
        this.checkSelectAll();
        this.selectionChange.emit(this.selected);
        this._onChange(this.selected);
    }
    getDropdownDisplay(selectedOptions, placeholder) {
        const selectedLength = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length;
        if (!selectedLength) {
            return placeholder;
        }
        if (selectedLength === 1) {
            return selectedOptions[0].viewValue;
        }
        return `${selectedOptions.length} ${this.selectedSuffix}`;
    }
    hasPlaceholderText(selectedOptions) {
        return (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) === 0;
    }
    linkClickHandler(e, option) {
        if (!(option.href || option.routerLink) || option.disabled) {
            e.preventDefault();
        }
    }
    linkFocusHandler(event, option) {
        const dropdownItem = event.target.parentElement;
        if (option.disabled) {
            return;
        }
        this.listItems.forEach((listItem) => {
            listItem.classList.remove('focused');
        });
        dropdownItem.classList.add('focused');
    }
    focusControlButton() {
        setTimeout(() => {
            if (this.hasIcon && this.toggleButtonWithIcon) {
                this.toggleButtonWithIcon.nativeElement.focus();
            }
            else if (this.splitActionText && this.splitActionButton) {
                this.splitActionButton.nativeElement.focus();
            }
            else if (this.controlButton) {
                this.controlButton.nativeElement.focus();
            }
            else {
                this.dropdownTrigger.focus();
            }
        }, 0);
    }
    getInitialSelectionLink() {
        var _a;
        if (!this.listItems || this.listItems.length === 0) {
            return undefined;
        }
        let item = this.listItems[0];
        if ((_a = this.selected) === null || _a === void 0 ? void 0 : _a.length) {
            const selectedValue = this.selected[0].value;
            this.listItems.forEach((listitem, index) => {
                const option = this._filteredOptions[index];
                if (option && option.value === selectedValue) {
                    item = listitem;
                }
            });
        }
        return item.querySelector('.dropdown-item');
    }
    incrementSelectionLink() {
        const currIdx = this.listItems.findIndex((e, i) => e.classList.contains('focused'));
        let focusedOption;
        for (let i = currIdx + 1; i < this.listItems.length; i++) {
            const currentListItem = this.listItems[i];
            if (currentListItem.classList.contains('disabled') ||
                currentListItem.classList.contains('option-group-title')) {
                continue;
            }
            else {
                focusedOption = this.listItems[i].querySelector('.dropdown-item');
                break;
            }
        }
        if (focusedOption) {
            this.focusedOption = focusedOption;
            this.focusedOption.focus();
        }
    }
    decrementSelectionLink() {
        const currIdx = this.listItems.findIndex((e, i) => e.classList.contains('focused'));
        let focusedOption;
        for (let i = currIdx - 1; i >= 0; i--) {
            const currentListItem = this.listItems[i];
            if (currentListItem.classList.contains('disabled') ||
                currentListItem.classList.contains('option-group-title')) {
                continue;
            }
            else {
                focusedOption = currentListItem.querySelector('.dropdown-item');
                break;
            }
        }
        if (focusedOption) {
            this.focusedOption = focusedOption;
            this.focusedOption.focus();
        }
    }
    onKey(event) {
        switch (event.key) {
            case 'Escape':
                this.hideDropdown(true);
                break;
            case 'Tab':
                event.preventDefault();
                this.hideDropdown(false);
                this.tabToNextFocusable(event.shiftKey);
                break;
            case ' ':
            case 'Enter':
                if (this.isExpanded && !this.searchIsFocused) {
                    this.focusedOption.click();
                    event.preventDefault();
                }
                break;
            case 'ArrowDown':
                this.incrementSelectionLink();
                event.preventDefault();
                break;
            case 'ArrowUp':
                this.decrementSelectionLink();
                event.preventDefault();
                break;
        }
    }
    tabToNextFocusable(previous = false) {
        const focusableElems = getFocusableElements();
        const dropdownButtonIndex = focusableElems.findIndex((element) => element === this.dropdownTrigger);
        if (dropdownButtonIndex !== -1) {
            const maxFocusableIndex = focusableElems.length - 1;
            let nextIndex = dropdownButtonIndex + (previous ? -1 : 1);
            if (nextIndex > maxFocusableIndex) {
                nextIndex = 0;
            }
            else if (nextIndex < 0) {
                nextIndex = maxFocusableIndex;
            }
            const nextFocusable = focusableElems[nextIndex];
            nextFocusable.focus();
        }
    }
    disabledProp(disabled) {
        return disabled ? '' : null;
    }
    getOptionLabel(option) {
        const optionValueList = [option.viewValue];
        if (option.viewDescription) {
            optionValueList.push(option.viewDescription);
        }
        for (const i in option.viewIcons) {
            if (optionValueList) {
                optionValueList.push(option.viewIcons[i].label);
            }
        }
        return optionValueList.join(' ');
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.changeDetectorRef.markForCheck();
    }
    writeValue(val) {
        if (val !== this.selected) {
            const selectedChange = new SimpleChange(this.selected, val, true);
            this.selected = val;
            this.ngOnChanges({ selected: selectedChange });
            this.changeDetectorRef.markForCheck();
        }
    }
    onScroll(event) {
        if (event.target.scrollHeight - event.target.scrollTop < event.target.offsetHeight) {
            this.scrollBottomReached.emit(event);
        }
    }
    searchOptions(event) {
        const { target } = event;
        this._searchTerm = target.value;
        if (this.searchable) {
            this.searchTerm.emit(this._searchTerm);
        }
        else {
            this._filteredOptions = this.filterOptions(this._searchTerm);
        }
        this.checkSelectAll();
    }
    trackById(_i, item) {
        return item.value;
    }
    setClosingActions() {
        const { overlayRef, destroy$ } = this;
        if (overlayRef) {
            const { hasBackdrop } = overlayRef.getConfig();
            const exitclick$ = hasBackdrop ? overlayRef.backdropClick() : overlayRef.outsidePointerEvents();
            const detach$ = overlayRef.detachments();
            this._closingActionsSubscription = merge(exitclick$, detach$)
                .pipe(takeUntil(destroy$))
                .subscribe((e) => {
                const isTrigger = e && this.isTriggerEvent(e);
                isTrigger && e.stopImmediatePropagation();
                this.hideDropdown();
            });
        }
    }
    isTriggerEvent(event) {
        const target = event.target;
        const element = this.dropdownTrigger;
        return target && (target === element || element.contains(target));
    }
    // currently, searchTerm filters on leaf nodes only
    filterOptions(searchTerm) {
        const options = [...this._flatOptions];
        if (!searchTerm.trim().length) {
            return options;
        }
        return options.filter((option) => {
            var _a;
            if ((_a = option.children) === null || _a === void 0 ? void 0 : _a.length) {
                return false;
            }
            else {
                return option.viewValue.toLowerCase().includes(searchTerm.trim().toLowerCase());
            }
        });
    }
}
DropdownComponent.ɵfac = function DropdownComponent_Factory(t) { return new (t || DropdownComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.Overlay), i0.ɵɵdirectiveInject(i2.TranslateService)); };
DropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DropdownComponent, selectors: [["mhe-dropdown"]], contentQueries: function DropdownComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, _c0, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.trigger = _t.first);
    } }, viewQuery: function DropdownComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 5);
        i0.ɵɵviewQuery(_c3, 5);
        i0.ɵɵviewQuery(_c4, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.controlButton = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toggleButtonWithIcon = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.splitActionButton = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownMenuPortal = _t.first);
    } }, inputs: { minWidth: "minWidth", maxWidth: "maxWidth", useCustomTrigger: "useCustomTrigger", splitActionText: "splitActionText", disabled: "disabled", image: "image", optionPosition: "optionPosition", toggleButtonAriaLabel: "toggleButtonAriaLabel", listboxLabel: "listboxLabel", selected: "selected", isMenu: "isMenu", icon: "icon", multiple: "multiple", filterable: "filterable", syncWidths: "syncWidths", buttonWidth: "buttonWidth", searchable: "searchable", selectAll: "selectAll", selectAllText: "selectAllText", placeholder: "placeholder", panelClass: "panelClass", closeOnBlur: "closeOnBlur", buttonClass: "buttonClass", options: "options", value: "value" }, outputs: { selectionChange: "selectionChange", searchTerm: "searchTerm", scrollBottomReached: "scrollBottomReached", close: "close", splitActionClick: "splitActionClick" }, features: [i0.ɵɵProvidersFeature([provideValueAccessor(DropdownComponent)]), i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c12, decls: 12, vars: 4, consts: [[1, "dropdown", 3, "click", "keyup"], [4, "ngIf", "ngIfElse"], ["cdkPortal", ""], ["dropdownMenuPortal", "cdkPortal"], ["optionContent", ""], ["optionTemplate", ""], ["splitButton", ""], ["custom", ""], ["type", "button", "aria-haspopup", "listbox", 3, "class", "id", "ngClass", "ngStyle", "click", 4, "ngIf", "ngIfElse"], ["iconButton", ""], ["type", "button", "aria-haspopup", "listbox", 3, "id", "ngClass", "ngStyle", "click"], ["controlButton", ""], [1, "text-truncate", "pe-3"], [1, "sr-only"], ["type", "button", "aria-haspopup", "listbox", 1, "btn", "btn-light", "btn-icon", "ngx-shared", 3, "id", "ngClass", "click"], ["toggleButtonWithIcon", ""], ["class", "avatar-image", 3, "src", 4, "ngIf"], [3, "class", 4, "ngIf"], [1, "avatar-image", 3, "src"], ["role", "listbox", 1, "dropdown-menu", "show", "border-0", 2, "position", "relative", 3, "scroll", "keydown"], ["class", "search-field px-2", 4, "ngIf"], ["role", "option", "class", "px-2 py-1", 4, "ngIf"], ["role", "presentation", 3, "disabled", "checkmark", "dpg-icon-confirmation", "option-group-options", "option-group-title", "ngClass", "ngStyle", "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "search-field", "px-2"], [1, "dropdown-menu-search"], ["type", "text", "autocomplete", "off", 1, "form-control", "search", 3, "placeholder", "blur", "focus", "keyup"], ["role", "option", 1, "px-2", "py-1"], [1, "form-check"], [1, "form-check-label"], ["type", "checkbox", "role", "menuitemcheckbox", 1, "form-check-input", 3, "checked", "indeterminate", "change"], [1, "visually-hidden"], ["role", "presentation", 3, "ngClass", "ngStyle", "click"], ["listItem", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["aria-hidden", "true", 3, "ngClass"], [1, "text-break"], [1, "view-icons"], [3, "class", "title", 4, "ngFor", "ngForOf"], ["class", "form-text m-0", "aria-hidden", "true", 4, "ngIf"], [3, "title"], ["aria-hidden", "true", 1, "form-text", "m-0"], [4, "ngIf"], ["role", "option", "class", "dropdown-item", 3, "is-header", "disabled", "fw-semibold", "click", "focus", 4, "ngIf"], ["class", "dropdown-item", 3, "href", "target", "disabled", "is-header", "click", "focus", 4, "ngIf"], ["routerLinkActive", "active", "class", "dropdown-item", 3, "routerLink", "disabled", "is-header", "click", "focus", 4, "ngIf"], ["role", "option", 1, "dropdown-item", 3, "click", "focus"], [1, "dropdown-item", 3, "href", "target", "click", "focus"], ["routerLinkActive", "active", 1, "dropdown-item", 3, "routerLink", "click", "focus"], ["type", "checkbox", "role", "menuitemcheckbox", 1, "form-check-input", 3, "value", "checked", "change"], [1, "btn", "btn-secondary", 3, "id", "click"], ["splitActionButton", ""], ["type", "button", 1, "btn", "btn-icon", "dpg-input-group-btn", 3, "ngClass", "click"], [1, "dpg-icon", "dpg-icon-dropdown-arrow-down"]], template: function DropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("click", function DropdownComponent_Template_div_click_0_listener() { return ctx._onTouch(); })("keyup", function DropdownComponent_Template_div_keyup_0_listener() { return ctx._onTouch(); });
        i0.ɵɵtemplate(1, DropdownComponent_ng_container_1_Template, 2, 2, "ng-container", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, DropdownComponent_ng_template_2_Template, 5, 8, "ng-template", 2, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, DropdownComponent_ng_template_4_Template, 6, 6, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(6, DropdownComponent_ng_template_6_Template, 2, 2, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(8, DropdownComponent_ng_template_8_Template, 8, 9, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(10, DropdownComponent_ng_template_10_Template, 1, 0, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r9 = i0.ɵɵreference(11);
        i0.ɵɵclassProp("btn-group", ctx.splitActionText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.useCustomTrigger)("ngIfElse", _r9);
    } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, i3.NgStyle, i4.RouterLinkWithHref, i4.RouterLinkActive, i5.CdkPortal, i6.MheCheckboxIndeterminateDirective, i3.AsyncPipe, i2.TranslatePipe], styles: ["mhe-dropdown{display:inline-block;max-width:100%}mhe-dropdown .avatar-image{width:35px;height:33px;border-radius:4px}mhe-dropdown .dropdown-toggle{width:100%}mhe-dropdown .dropdown-toggle::after{position:absolute;right:.5em;top:50%;transform:translateY(-50%)}.dropdown-menu.ngx-shared li>.dropdown-item{padding-left:1.5em;white-space:normal}.dropdown-menu.ngx-shared li.checkmark{position:relative}.dropdown-menu.ngx-shared li.checkmark::before{width:1.5em;height:1.5em;position:absolute;left:0;top:.25em}\n"], encapsulation: 2, data: { animation: [
            trigger('optionSelection', [
                state('selected', style({ backgroundColor: '#e0e7e9' })),
                transition('* => selected', [
                    animate(`${DROPDOWN_SELECTED_STATE_TIME}ms`, keyframes([
                        style({ backgroundColor: 'white', offset: 0 }),
                        style({ backgroundColor: '#e0e7e9', offset: 1.0 }),
                    ])),
                ]),
            ]),
            trigger('hideDropdown', [
                state('dropdownHidden', style({ opacity: 0 })),
                transition('* => dropdownHidden', animate(`${DROPDOWN_SELECTED_STATE_TIME}ms`)),
            ]),
        ] }, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownComponent, [{
        type: Component,
        args: [{ providers: [provideValueAccessor(DropdownComponent)], selector: 'mhe-dropdown', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, animations: [
                    trigger('optionSelection', [
                        state('selected', style({ backgroundColor: '#e0e7e9' })),
                        transition('* => selected', [
                            animate(`${DROPDOWN_SELECTED_STATE_TIME}ms`, keyframes([
                                style({ backgroundColor: 'white', offset: 0 }),
                                style({ backgroundColor: '#e0e7e9', offset: 1.0 }),
                            ])),
                        ]),
                    ]),
                    trigger('hideDropdown', [
                        state('dropdownHidden', style({ opacity: 0 })),
                        transition('* => dropdownHidden', animate(`${DROPDOWN_SELECTED_STATE_TIME}ms`)),
                    ]),
                ], template: "<div class=\"dropdown\" [class.btn-group]=\"splitActionText\" (click)=\"_onTouch()\" (keyup)=\"_onTouch()\">\n  <ng-container *ngIf=\"!useCustomTrigger; else custom\">\n    <ng-container *ngIf=\"!splitActionText; else splitButton\">\n      <button\n        *ngIf=\"!icon && !image; else iconButton\"\n        #controlButton\n        type=\"button\"\n        [class]=\"setButtonClass()\"\n        [id]=\"templateUuids.get('buttonId')\"\n        [attr.disabled]=\"disabledProp(disabled)\"\n        [attr.aria-expanded]=\"isExpanded\"\n        aria-haspopup=\"listbox\"\n        [ngClass]=\"{ open: isExpanded }\"\n        [ngStyle]=\"{ 'width.px': buttonWidth }\"\n        (click)=\"toggleMenu($event)\"\n      >\n        <span class=\"text-truncate pe-3\">\n          <span class=\"sr-only\">{{ toggleButtonAriaLabel }} </span>{{ currentSelection }}\n        </span>\n      </button>\n\n      <ng-template #iconButton>\n        <button\n          #toggleButtonWithIcon\n          type=\"button\"\n          class=\"btn btn-light btn-icon ngx-shared\"\n          aria-haspopup=\"listbox\"\n          [id]=\"templateUuids.get('buttonId')\"\n          [attr.disabled]=\"disabledProp(disabled)\"\n          [attr.aria-expanded]=\"isExpanded\"\n          [ngClass]=\"{ 'btn-padding': image }\"\n          (click)=\"toggleMenu($event)\"\n        >\n          <span class=\"sr-only\">{{ toggleButtonAriaLabel }}</span>\n          <img *ngIf=\"image\" class=\"avatar-image\" [src]=\"image\" />\n          <i *ngIf=\"icon && !image\" class=\" {{ icon }}\"></i>\n        </button>\n      </ng-template>\n    </ng-container>\n  </ng-container>\n</div>\n\n<ng-template cdkPortal #dropdownMenuPortal=\"cdkPortal\">\n  <div\n    [@hideDropdown]=\"!multiple && triggerHideDropdown ? 'dropdownHidden' : ''\"\n    (@hideDropdown.done)=\"hideDropdownAnimationDone($event)\"\n  >\n    <ul\n      role=\"listbox\"\n      class=\"dropdown-menu show border-0\"\n      style=\"position: relative\"\n      [attr.aria-label]=\"listboxLabel\"\n      [class.dropdown-menu-right]=\"optionPosition === 'left'\"\n      (scroll)=\"onScroll($event)\"\n      (keydown)=\"onKey($event)\"\n    >\n      <li *ngIf=\"filterable || searchable\" class=\"search-field px-2\">\n        <div class=\"dropdown-menu-search\">\n          <input\n            type=\"text\"\n            autocomplete=\"off\"\n            class=\"form-control search\"\n            (blur)=\"searchIsFocused = false\"\n            (focus)=\"searchIsFocused = true\"\n            placeholder=\"{{ 'ngx-shared-search' | mheTranslate | async }}\"\n            (keyup)=\"searchOptions($event)\"\n          />\n        </div>\n      </li>\n\n      <li *ngIf=\"multiple && selectAll\" role=\"option\" class=\"px-2 py-1\">\n        <div class=\"form-check\">\n          <label class=\"form-check-label\">\n            <input\n              type=\"checkbox\"\n              role=\"menuitemcheckbox\"\n              class=\"form-check-input\"\n              [checked]=\"allSelected\"\n              [indeterminate]=\"!allSelected && (selected?.length ?? 0) > 0\"\n              (change)=\"selectAllOptions()\"\n            />\n            {{ 'ngx-shared-select-all' | mheTranslate | async }}\n            <span class=\"visually-hidden\">{{ 'ngx-shared-menu-option' | mheTranslate | async }}</span>\n          </label>\n        </div>\n      </li>\n\n      <li\n        *ngFor=\"let option of options; trackBy: trackById; let i = index\"\n        #listItem\n        role=\"presentation\"\n        [attr.aria-disabled]=\"option.disabled\"\n        [class.disabled]=\"option.disabled\"\n        [class.checkmark]=\"!multiple && containsOption(option, selected)\"\n        [class.dpg-icon-confirmation]=\"!multiple && containsOption(option, selected)\"\n        [class.option-group-options]=\"_isChild[i]\"\n        [class.option-group-title]=\"!!option.children\"\n        [ngClass]=\"{ 'px-2 py-1': multiple, 'pe-none': !!option.children }\"\n        [ngStyle]=\"{ 'margin-left': !!option.children ? '-1rem' : null }\"\n        (click)=\"!multiple ? selectOption(option) : ''\"\n      >\n        <ng-container *ngTemplateOutlet=\"optionTemplate; context: getContext(i, option)\"></ng-container>\n      </li>\n    </ul>\n  </div>\n</ng-template>\n\n<ng-template\n  #optionContent\n  let-viewValue=\"viewValue\"\n  let-viewIcons=\"viewIcons\"\n  let-viewDescription=\"viewDescription\"\n>\n  <span aria-hidden=\"true\" [ngClass]=\"{ 'view-title': viewDescription }\">\n    <span class=\"text-break\">{{ viewValue }}</span>\n    <span class=\"view-icons\">\n      <i\n        *ngFor=\"let viewIcon of viewIcons\"\n        class=\"dpg-icon {{ viewIcon.class }}\"\n        title=\"{{ viewIcon.label }}\"\n      ></i>\n    </span>\n  </span>\n\n  <p *ngIf=\"viewDescription\" class=\"form-text m-0\" aria-hidden=\"true\">{{ viewDescription }}</p>\n</ng-template>\n\n<ng-template #optionTemplate let-option=\"option\" let-isChild=\"isChild\" let-isHeader=\"option.children\">\n  <ng-container *ngIf=\"!multiple\">\n    <button\n      *ngIf=\"(!option.routerLink && !option.href) || option.disabled\"\n      role=\"option\"\n      class=\"dropdown-item\"\n      [class.is-header]=\"isHeader || null\"\n      [class.disabled]=\"option.disabled\"\n      [class.fw-semibold]=\"!!option.children\"\n      [attr.tabindex]=\"!option.disabled && !option.children ? 0 : null\"\n      [attr.aria-label]=\"getOptionLabel(option)\"\n      [attr.aria-selected]=\"containsOption(option, selected)\"\n      [@optionSelection]=\"\n        triggerOptionSelectionAnimation && containsOption(option, selected) ? 'selected' : ''\n      \"\n      (@optionSelection.done)=\"optionSelectionAnimationDone($event)\"\n      (click)=\"linkClickHandler($event, option)\"\n      (focus)=\"linkFocusHandler($event, option)\"\n    >\n      <ng-container *ngTemplateOutlet=\"optionContent; context: option\"></ng-container>\n    </button>\n\n    <a\n      *ngIf=\"option.href\"\n      href=\"{{ option.href }}\"\n      target=\"{{ option.target }}\"\n      class=\"dropdown-item\"\n      [class.disabled]=\"option.disabled\"\n      [class.is-header]=\"isHeader || null\"\n      [@optionSelection]=\"\n        triggerOptionSelectionAnimation && containsOption(option, selected) ? 'selected' : ''\n      \"\n      (@optionSelection.done)=\"optionSelectionAnimationDone($event)\"\n      (click)=\"linkClickHandler($event, option)\"\n      (focus)=\"linkFocusHandler($event, option)\"\n    >\n      <ng-container *ngTemplateOutlet=\"optionContent; context: option\"></ng-container>\n    </a>\n\n    <a\n      *ngIf=\"option.routerLink\"\n      routerLinkActive=\"active\"\n      routerLink=\"{{ option.routerLink }}\"\n      class=\"dropdown-item\"\n      [class.disabled]=\"option.disabled\"\n      [class.is-header]=\"isHeader || null\"\n      [@optionSelection]=\"\n        triggerOptionSelectionAnimation && containsOption(option, selected) ? 'selected' : ''\n      \"\n      (@optionSelection.done)=\"optionSelectionAnimationDone($event)\"\n      (click)=\"linkClickHandler($event, option)\"\n      (focus)=\"linkFocusHandler($event, option)\"\n    >\n      <ng-container *ngTemplateOutlet=\"optionContent; context: option\"></ng-container>\n    </a>\n  </ng-container>\n\n  <ng-container *ngIf=\"multiple\">\n    <div class=\"form-check\">\n      <label class=\"form-check-label\">\n        <input\n          type=\"checkbox\"\n          role=\"menuitemcheckbox\"\n          class=\"form-check-input\"\n          [value]=\"option.value\"\n          [checked]=\"containsOption(option, selected)\"\n          (change)=\"selectOption(option)\"\n        />\n        <ng-container *ngTemplateOutlet=\"optionContent; context: option\"></ng-container>\n      </label>\n    </div>\n  </ng-container>\n</ng-template>\n\n<ng-template #splitButton>\n  <button\n    [id]=\"templateUuids.get('buttonId')\"\n    class=\"btn btn-secondary\"\n    (click)=\"splitActionClick.emit($event)\"\n    #splitActionButton\n  >\n    {{ splitActionText }}\n  </button>\n  <button\n    type=\"button\"\n    [attr.disabled]=\"disabledProp(disabled)\"\n    [attr.aria-expanded]=\"isExpanded\"\n    class=\"btn btn-icon dpg-input-group-btn\"\n    [ngClass]=\"{ placeholder: hasPlaceholderText(selected), open: isExpanded }\"\n    (click)=\"toggleMenu($event)\"\n    #controlButton\n  >\n    <i class=\"dpg-icon dpg-icon-dropdown-arrow-down\">\n      <span class=\"sr-only\">{{ toggleButtonAriaLabel }}</span>\n    </i>\n  </button>\n</ng-template>\n\n<ng-template #custom> <ng-content></ng-content> </ng-template>\n", styles: ["mhe-dropdown{display:inline-block;max-width:100%}mhe-dropdown .avatar-image{width:35px;height:33px;border-radius:4px}mhe-dropdown .dropdown-toggle{width:100%}mhe-dropdown .dropdown-toggle::after{position:absolute;right:.5em;top:50%;transform:translateY(-50%)}.dropdown-menu.ngx-shared li>.dropdown-item{padding-left:1.5em;white-space:normal}.dropdown-menu.ngx-shared li.checkmark{position:relative}.dropdown-menu.ngx-shared li.checkmark::before{width:1.5em;height:1.5em;position:absolute;left:0;top:.25em}/*# sourceMappingURL=dropdown.component.css.map */\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.Overlay }, { type: i2.TranslateService }]; }, { minWidth: [{
            type: Input
        }], maxWidth: [{
            type: Input
        }], useCustomTrigger: [{
            type: Input
        }], splitActionText: [{
            type: Input
        }], disabled: [{
            type: Input
        }], image: [{
            type: Input
        }], optionPosition: [{
            type: Input
        }], toggleButtonAriaLabel: [{
            type: Input
        }], listboxLabel: [{
            type: Input
        }], selected: [{
            type: Input
        }], isMenu: [{
            type: Input
        }], icon: [{
            type: Input
        }], multiple: [{
            type: Input
        }], filterable: [{
            type: Input
        }], syncWidths: [{
            type: Input
        }], buttonWidth: [{
            type: Input
        }], searchable: [{
            type: Input
        }], selectAll: [{
            type: Input
        }], selectAllText: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], panelClass: [{
            type: Input
        }], closeOnBlur: [{
            type: Input
        }], buttonClass: [{
            type: Input
        }], options: [{
            type: Input
        }], value: [{
            type: Input
        }], selectionChange: [{
            type: Output
        }], searchTerm: [{
            type: Output
        }], scrollBottomReached: [{
            type: Output
        }], close: [{
            type: Output
        }], splitActionClick: [{
            type: Output
        }], trigger: [{
            type: ContentChild,
            args: ['mheDropdownTrigger', { read: ElementRef }]
        }], controlButton: [{
            type: ViewChild,
            args: ['controlButton']
        }], toggleButtonWithIcon: [{
            type: ViewChild,
            args: ['toggleButtonWithIcon']
        }], splitActionButton: [{
            type: ViewChild,
            args: ['splitActionButton']
        }], dropdownMenuPortal: [{
            type: ViewChild,
            args: ['dropdownMenuPortal', { static: true }]
        }] }); })();
